<div #myModal class="modal fade" id="modal-default" style="border-color: transparent;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <br>
        <br>
     

        <h4 class="modal-title">Política de cambios</h4>
        <button type="button"  data-dismiss="modal" aria-label="Close" style="width: 48px;height: 48px;font-size: xx-large;border-style: none;background-color: transparent;" (click)="OnCerrarDialogo()">
          <span style="color: #000000;padding-top: 0.5em;
padding-bottom: 0.5em;font-size: 35px;">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="border-color: rgb(0, 0, 0);border-style:solid;">
        
        <strong>POLÍTICAS DE CAMBIO.</strong><br>
                        ESTAS POLÍTICAS SON FUNCIONALES DE ACUERDO A LOS SIGUIENTES CASOS:<br>
                        1) Plazo para solicitar el cambio es en un rango de 10 días contando a partir de la fecha en que recibes el pedido.<br>
                        2) Productos ofertados no tienen cambios.<br>
                        3) El nuevo producto debe de ser del mismo valor o más alto  (solo se paga la diferencia).<br>
                        4) Todo cambio tiene costo de envío.<br>

                <strong> REQUISITOS:</strong><br>
                       
                        1) Conservar la caja y el empaque original de los productos.<br>
                        2) El producto debe estar limpio y en condiciones originales.<br>
                        3) Debe entregarse con sus etiquetas sin estar desprendidas y en el empaque original.<br>
                        

      </div>
      <div class="modal-footer justify-content-center">
        
        <button type="button" class="btn btn-danger" (click)="OnLoginCiente()" style="height: 48px;font-size: larger;">Estoy de acuerdo.</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

          <div class="content-header">
            <div class="container">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <h1 class="m-0"> Sucursales<small></small></h1>
                </div><!-- /.col -->
                
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->
            </div>

           <div class="card card-success">
            <div class="card-body">
              <div class="row">
              
                  <!-- title row -->
            <div class="row">
            <div class="col-10">
            <div class="row invoice-info">

            <div class="col-sm-4 invoice-col">
            <address>
              <strong>Plaza Américas</strong><br>
             Centro Comercial PLAZA AMERICAS<br>
              Local No. 35 Mazatenango<br>
            </address>
           </div>

            <div class="col-sm-4 invoice-col">
            <address>
              <strong>Paseo Carnaval</strong><br>
              Centro Comercial PASEO CARNAVAL<br>
              Circunvalación, Mazatenango<br>
            </address>
             </div>

             <div class="col-sm-4 invoice-col">
                <address>
                  <strong>Interplaza</strong><br>
                  Centro Comercial INTER-PLAZA<br>
                  Local No. 4, Escuintla<br>
                </address>
                 </div>
                 <br>

                 <div class="col-sm-4 invoice-col">
                  <address>
                    <strong>Registra tu cambio.</strong><br>
                      <br>
                      <br>

                      <address>
                       
                        <div class="input-group-append" *ngIf="ocultar == false">
                          <button type="button" class="btn-primary " (click)="OnAbrirDialogo()  " style="height: 55px;font-weight:bold;font-size: 20px;color: #ffffff;background-color: #0058db;">Ingresa aquí</button>
                           
  
                        </div>
                      </address>

                     
                  
                  </address>



                  <div class="mt-4 product-share" *ngIf="ocultar == false">
                    <a href="https://www.facebook.com/andreaplazaamerica" style="color: #252525;">
                      <i class="fab fa-facebook-square fa-4x"></i>
                    </a>
                    <a href="https://www.instagram.com/zapateriaandreagt/profilecard/?igsh=MWllOXB0bHk2amYxMg==" style="color: #252525;">
                      <i class="fab fa-instagram-square fa-4x"></i>
                    </a>
                
                   
                  </div>


                   </div>


           </div>
          </div>

      
            </div>
              </div><!-- /.row -->
          </div><!-- /.container-fluid -->
        </div>